module.exports = __webpack_public_path__ + "img/homefooter_icon06.0d6ee599.png";